import axios from "../axios"
import { BASE_URL, encodeQueryFilter } from "../Utils"

const ASSIGNMENT_URL = "/assignments"
const FACILITY_BASE_URL = BASE_URL + "/facilities";
const USERS_URL = BASE_URL + "/users";

export async function getWeeklyAssignments(filter={}) {
   return axios({
    "url": `${BASE_URL}${ASSIGNMENT_URL}?filter=${encodeQueryFilter(filter)}`,
    "method": "get",
  })
}

export  function getFacilities(filter={}) {
    return axios({
    url: `${FACILITY_BASE_URL}?filter=${encodeQueryFilter(filter)}`,
    method: "get",
  });
}

export async function getUsers(filter) {
  let url = USERS_URL;
  if (filter) {
    url += `?filter=${encodeQueryFilter(filter)}`;
  }
  return axios({
    url,
    method: "get",
  });
}